import { render, staticRenderFns } from "./variant-image.vue?vue&type=template&id=6027e9f7"
import script from "./variant-image.vue?vue&type=script&lang=js"
export * from "./variant-image.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports